import './document_viewer.css.scss';

class DocumentViewer {
  download(path, filename) {
    const anchor = document.createElement('a');
    anchor.href = path;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  print(src, link) {
    const iframe = document.createElement('iframe');
    iframe.style.height = 0;
    iframe.style.visibility = 'hidden';
    iframe.style.width = 0;
    iframe.setAttribute('srcdoc', '<html><body></body></html>');

    document.body.appendChild(iframe);
    iframe.addEventListener('load', function () {
      const image = document.createElement('img');
      image.src = src;
      image.style.maxWidth = '100%';
      const body = iframe.contentDocument.body;
      body.appendChild(image);
      image.addEventListener('load', function() {
        iframe.contentWindow.print();
      });
    });

    iframe.contentWindow.onafterprint = function(){
      iframe.remove();
      link.classList.remove('disabled');
    };
  }

  bindEvents() {
    document.querySelectorAll('.js-preview-document').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const src = link.closest('li').querySelector('img').src;
        document.dispatchEvent(new CustomEvent('sm-modal:open', {detail: {
          content: `<div class="js-preview-wrap document-preview-wrap sm-modal-content"><div class="document-preview-header">Preview Document</div><div class="js-preview"><embed src=${src}></div><div class="document-preview-footer"><button class="btn btn-primary js-print-document">Print</button></div></div>`,
          onComplete: () => {
            document.querySelectorAll('.js-print-document').forEach(link => {
              link.addEventListener('click', e => {
                e.preventDefault();
                link.classList.add('disabled');
                this.print(src, link);
                return false;
              });
            });
          }
        }}));
        return false;
      });
    });

    document.querySelectorAll('.js-download-document').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const src = link.closest('li').querySelector('img').src;
        this.download(src, link.dataset.name);
        return false;
      });
    });
  }

  init() {
    this.bindEvents();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const ra = document.getElementById('rental_application_show');
  if (ra) {
    const viewer = new DocumentViewer();
    viewer.init();
  }
});
